var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9556 2.46923C17.7333 2.05385 17.2333 1.89231 16.8222 2.12308L10 5.94231L3.17778 2.12308C2.77778 1.89231 2.26667 2.05385 2.04444 2.46923C1.82222 2.88462 1.97778 3.41538 2.37778 3.64615L9.6 7.68462C9.84445 7.82308 10.1444 7.82308 10.3889 7.68462L17.6111 3.64615C18.0222 3.41538 18.1778 2.89615 17.9556 2.46923ZM17.7778 0C19 0 20 1.03846 20 2.30769V12.6923C20 13.9615 19 15 17.7778 15H2.22222C1 15 0 13.9615 0 12.6923V2.30769C0 1.03846 1 0 2.22222 0H17.7778Z",
    fill: "#80808F"
  })));
}

export default SvgMessage;